<template>
  <div
    :style="{
      padding: '0px',
      margin: '-50px -50px 0 -50px',
      minHeight: '480px',
      position: 'relative',
    }"
    ref="pos_top"
    id="pos_top"
  >
    <cover />
  </div>
  <div id="pos_solution"
    :style="{
      padding: '0px',
      margin: '50px -50px 0 -50px',
      minHeight: '480px',
      position: 'relative',
    }"
    ref="pos_solution"
   
  >
    <solution />
  </div>
  <div  id="pos_service"
    :style="{
      padding: '0px',
      margin: '50px -50px 0 -50px',
      minHeight: '480px',
      position: 'relative',
    }"
    ref="pos_service"

  >
    <service />
  </div>
  <div id="pos_portfolio"
    :style="{
      padding: '0px',
      margin: '50px -50px 0 -50px',
      minHeight: '480px',
      position: 'relative',
    }"
    ref="pos_portfolio"
    
  >
    <portfolio />
  </div>
  <div id="pos_about"
    :style="{
      padding: '0px',
      margin: '0 -50px 0 -50px',
      minHeight: '480px',
      position: 'relative',
    }"
    ref="pos_about"
    
  >
    <about />
  </div>
</template>
<script>
import Cover from "../components/home/Cover.vue";
import Solution from "../components/home/Solution.vue";
import Portfolio from "../components/home/Portfolio.vue";
import About from "../components/home/About.vue";
import Service from "../components/home/Service.vue";
export default {
  name: "Home",
  components: {
    Cover,
    Solution,
    Portfolio,
    About,
    Service,
  },

  methods: {
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop - 64;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style></style>
